import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    JobProfilesPage: lazyLoad(async () => {
        const { JobProfilesListPage } = await import('./list/JobProfilesListPage');

        return { default: JobProfilesListPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.job-profiles.headline',
        page: lazy.JobProfilesPage,
        path: route.patterns.jobProfiles,
    },
];
